import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { ScreenOrientation } from '@capacitor/screen-orientation';
import { App as CapApp } from '@capacitor/app';

/**
 * Check if running on native platform
 */
function isNativePlatform(): boolean {
  return (window as any).Capacitor !== undefined;
}

/**
 * Initialize mobile-specific features
 * Should be called once when the app loads
 */
export async function initializeMobileApp(): Promise<void> {
  if (!isNativePlatform()) {
    // Not a native app
    return;
  }

  try {
    // Customize Status Bar
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#000000' });

    // Configure keyboard behavior
    await Keyboard.setAccessoryBarVisible({ isVisible: false });
    await Keyboard.setScroll({ isEnabled: true });

    // Set screen orientation (allow all orientations)
    await ScreenOrientation.unlockOrientation();

    console.log('Mobile app initialized successfully');
  } catch (error) {
    // Features may not be available on all devices/platforms
    console.warn('Some mobile features are not available:', error);
  }
}

/**
 * Safe area aware styles for notch/status bar handling
 */
export const getSafeAreaStyle = () => ({
  // Add extra top padding (12px) for better visibility on mobile
  // Use safe-area inset where supported, with a fallback
  paddingTop: `calc(max(env(safe-area-inset-top, 0px), 0px) + 12px)`,
  paddingLeft: `max(env(safe-area-inset-left, 0px), 0px)`,
  paddingRight: `max(env(safe-area-inset-right, 0px), 0px)`,
  paddingBottom: `max(env(safe-area-inset-bottom, 0px), 0px)`,
});
